<template>
  <div
    class="universal-tooltip"
    v-bind="wrapperProps"
    @click.capture="onShowTooltip"
    @mouseleave="onHideTooltip"
  >
    <slot />
    <hr-tooltip
      v-if="showTooltip && text"
      v-model="show"
      v-bind="tooltipProps"
    >
      {{ text }}
    </hr-tooltip>
  </div>
</template>

<script>
import { omit, pick } from 'lodash';
import { HrTooltip } from 'src/design-system';

export default {
  name: 'Tooltip',

  components: { HrTooltip },

  inheritAttrs: false,

  props: {
    delayTime: {
      type: Number,
      default: 3000,
    },
    showTooltip: {
      type: Boolean,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      show: false,
    };
  },

  computed: {
    isTouchDevice() {
      return this.$q.platform.has.touch && !this.$q.platform.is.desktop;
    },

    tooltipProps() {
      return omit(this.$attrs, ['class', 'style']);
    },

    wrapperProps() {
      return pick(this.$attrs, ['class', 'style']);
    },
  },

  watch: {
    show(val) {
      if (val && this.isTouchDevice) {
        setTimeout(() => {
          this.show = false;
        }, this.delayTime);
      }
    },
  },

  methods: {
    onShowTooltip() {
      this.show = true;
    },

    onHideTooltip() {
      this.show = false;
    },
  },
};
</script>
